export const SEO_PREVIEW_MODE_STORAGE_KEY = 'gwe-seo-preview-mode';

const PREVIEW_HOST_PATTERNS = [
  'preview.emergentagent.com',
  'preview.emergent.host',
  'localhost',
  '127.0.0.1',
];

export const isPreviewEnvironment = () => {
  if (typeof window === 'undefined') return false;
  const host = String(window.location.hostname || '').toLowerCase();
  return PREVIEW_HOST_PATTERNS.some((pattern) => host.includes(pattern));
};

const isTruthy = (value) => ['1', 'true', 'yes', 'on'].includes(String(value || '').toLowerCase());

export const getSeoPreviewModeFromSearch = (search = '') => {
  const params = new URLSearchParams(String(search || ''));
  return isTruthy(params.get('seo-preview'));
};

export const getStoredSeoPreviewMode = () => {
  if (typeof window === 'undefined') return false;
  return isTruthy(window.localStorage.getItem(SEO_PREVIEW_MODE_STORAGE_KEY));
};

export const getSeoPreviewMode = (search = '') => {
  if (typeof window === 'undefined') return false;
  if (!isPreviewEnvironment()) return false;
  return getSeoPreviewModeFromSearch(search) || getStoredSeoPreviewMode();
};

export const setSeoPreviewMode = (enabled) => {
  if (typeof window === 'undefined') return;
  if (!isPreviewEnvironment()) {
    window.localStorage.removeItem(SEO_PREVIEW_MODE_STORAGE_KEY);
    return;
  }
  window.localStorage.setItem(SEO_PREVIEW_MODE_STORAGE_KEY, enabled ? 'true' : 'false');
  window.dispatchEvent(new Event('seo-preview-mode-changed'));
};